module.exports = __webpack_public_path__ + "static/media/fog.7850bef1.svg";